const updateClasses = (el, vnode) => {
  const classes = el.attributes.class?.value?.split(' ');
  if (!classes) {
    return;
  }
  const store = vnode.context.$store;
  const { theme } = store.state.theme;
  if (theme === 'default') {
    return;
  }
  const classesWithModifiers = classes
    .filter((baseClass) => !baseClass.includes(theme))
    .map((baseClass) => `${baseClass} ${baseClass}--${theme}`)
    .join(' ');
  el.setAttribute('class', classesWithModifiers);
};

// eslint-disable-next-line import/prefer-default-export
export const ApplyTheme = {
  inserted: (el, bind, vnode) => updateClasses(el, vnode),
  update: (el, bind, vnode) => updateClasses(el, vnode),
};
